import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const BUILDING_TYPE_ENDPOINTS = {
  V1: createEndpoints('v1', {
    BUILDING_TYPES: '/building-types/',
    BUILDING_STATUS: '/building-status/',
    BUILDING_TYPE: '/building-type/',
  }),
} as const;
